import type { SVGProps } from "react";
export interface GrapesIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GrapesIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GrapesIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M7.375 17.25q0-.344.046-.674a4.85 4.85 0 0 1-3.041-.566 2.624 2.624 0 1 0 3.608 3.607 4.85 4.85 0 0 1-.613-2.367m9.902-12.106a3.68 3.68 0 0 1 3.578-.711 1.125 1.125 0 0 1-.71 2.134 1.44 1.44 0 0 0-1.468.347l-.882.882a1.125 1.125 0 0 1-1.59-1.591l.881-.882.19-.179ZM9.625 17.25a2.625 2.625 0 0 0 5.229.335 1.126 1.126 0 0 1 2.232.284 4.877 4.877 0 0 1-7.542 3.436 4.86 4.86 0 0 1-3.794 1.82A4.875 4.875 0 0 1 .875 18.25a4.86 4.86 0 0 1 1.82-3.795 4.875 4.875 0 0 1 3.437-7.541 1.126 1.126 0 0 1 .283 2.232 2.626 2.626 0 1 0 2.42 1.008 1.125 1.125 0 0 1 1.786-1.37 4.86 4.86 0 0 1 .956 3.638 4.86 4.86 0 0 1 3.32.734l.317.224.088.074a1.125 1.125 0 0 1-1.362 1.777l-.095-.066-.17-.12a2.626 2.626 0 0 0-4.05 2.205"
      />
      <path
        fill={color}
        d="M20.875 14.75a2.625 2.625 0 0 0-2.375-2.613 4.89 4.89 0 0 1-2.853 2.283 2.625 2.625 0 1 0 5.228.33m-4-5a2.625 2.625 0 1 0-5.25 0 2.625 2.625 0 0 0 5.25 0m2.244.203a4.876 4.876 0 1 1-5.744 4.797c0-.069.006-.137.009-.205a4.875 4.875 0 0 1-3.93-3.93c-.068.002-.136.01-.204.01a4.875 4.875 0 1 1 4.796-5.745 4.875 4.875 0 0 1 5.079 4.87q-.002.102-.006.203M6.625 5.75A2.625 2.625 0 0 0 9.25 8.375q.167-.002.328-.023a4.9 4.9 0 0 1 2.284-2.854 2.624 2.624 0 0 0-5.237.252"
      />
    </svg>
  );
}
